<template>
  <div>
    <a-alert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-opco style="width: 100%;" v-model:value="opco" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-province style="width: 100%;" v-model:value="provinsi" v-model:opco="opco" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-area
          style="width: 100%;"
          v-model:value="area"
          v-model:provinsi="provinsi"
          v-model:opco="opco"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-kabupaten-kota style="width: 100%;" v-model:value="kabupaten" v-model:area="area" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-brand style="width: 100%;" v-model:value="brand" v-model:brand="brand" />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-month-picker
          style="width: 100%;"
          v-model:value="start_date"
          placeholder="Dari Bulan"
          :disabled-date="disabledStartDate"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-month-picker
          v-model:value="end_date"
          placeholder="Sampai Bulan"
          style="width: 100%;"
          :disabled-date="disabledEndDate"
        />
      </ACol>
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-button type="primary" title="cari" @click="search" :loading="isFetching">
          <i class="fa fa-search" aria-hidden="true" v-if="!isFetching"></i>
          <span v-else>Memuat Data ...</span>
        </a-button>
        <a-button
          class="ml-2"
          title="download excel"
          type="primary"
          @click="fetchXlsx"
          :loading="isDownloading"
        >
          <i class="fa fa-file-excel-o" aria-hidden="true" v-if="!isDownloading"></i>
          <span v-else>Downloading ...</span>
        </a-button>
      </ACol>
    </ARow>

    <div class="row mt-4">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body">
              <e-chart :title="title" vif="!isFetching" :response="response" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineAsyncComponent,
  defineComponent,
  ref,
  reactive,
  inject,
  onMounted,
  computed,
  nextTick,
  toRefs,
  onBeforeMount,
  provide,
  watch,
} from 'vue'
import Loading from '@/components/Loading'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterArea from '@/components/filter/FilterArea'
import FilterOpco from '@/components/filter/FilterOpco'
// import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterBrand from '@/components/filter/FilterBrand'
// import FilterProducts from '@/components/filter/FilterProduct'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import { useDisabledDate } from '@/composables/DisabledDate'
import qs from 'qs'
import moment from 'moment'

const acolumns = [
  {
    title: 'bulan',
    dataIndex: 'bulan',
  },
  {
    title: 'Kode Produk',
    dataIndex: 'product_code',
  },
  {
    title: 'Produk',
    dataIndex: 'product_name',
  },
  {
    title: 'Volume',
    dataIndex: 'volume_ton',
  },
  {
    title: 'Brand',
    dataIndex: 'brand_name',
  },
  {
    title: 'Area AP',
    dataIndex: 'opco',
  },
  {
    title: 'Provinsi',
    dataIndex: 'provinsi',
  },
  {
    title: 'Area',
    dataIndex: 'area',
  },
  {
    title: 'Kabupaten / Kota',
    dataIndex: 'kabupaten',
  },
  {
    title: 'Harga Jual Rata-rata',
    dataIndex: 'avg_price',
  },
  {
    title: 'Harga Jual Minimal',
    dataIndex: 'min_price',
  },
  {
    title: 'Harga Jual Maksimal',
    dataIndex: 'max_price',
  },
]

export default defineComponent({
  name: 'MFilter',
  components: {
    // MModal,
    FilterProvince,
    FilterArea,
    FilterOpco,
    // FilterDistributor,
    FilterBrand,
    // FilterProducts,
    FilterKabupatenKota,
    EChart: defineAsyncComponent({
      loader: () => import('./EChart.vue' /* webpackChunkName: "eChart" */),
      loadingComponent: Loading,
    }),
  },
  setup() {
    const data = ref([])
    const searchText = ref('')
    const searchInput = ref(null)
    const current1 = ref(1)
    const q = ref('')

    const opco = ref([])
    const provinsi = ref([])
    const kabupaten = ref([])
    const distributor = ref([])
    const area = ref([])
    const brand = ref([])
    const errorMessage = ref(null)
    const {
      start_date,
      end_date,
      disabledStartDate,
      firstDayMonth,
      lastDayMonth,
      disabledEndDate,
      startDate,
      endDate,
    } = useDisabledDate()
    const columns = ref([])
    const response = ref()

    columns.value = acolumns

    const params = ref({})
    const fetchData = () => {
      const _params = {
        // page: page.value,
        // 'per-page': perPage.value,
        area: area.value,
        opco: opco.value,
        provinsi: provinsi.value,
        kabupaten: kabupaten.value,
        //  product: products.value,
        brand: brand.value,
        distributor: distributor.value,
        start_date: firstDayMonth.value,
        end_date: lastDayMonth.value,
        q: q.value,
      }
      params.value = Object.assign({}, _params)
      state.isFetching = true
      apiClient
        .get('api/report/grafik-brand', {
          params: _params,
        })
        .then(({ data }) => {
          response.value = data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => {
          state.isFetching = false
        })
    }
    const fetchXlsx = () => {
      state.isDownloading = true
      apiClient
        .get('/api/report/performance-brand', {
          params: {
            ...params.value,
            _export: 'xls',
            _columns: columns.value
              .filter(c => c.dataIndex !== null && c.dataIndex !== undefined)
              .map(({ dataIndex: key, title }) => ({ key, title })),
          },
          paramsSerializer: function(params) {
            return qs.stringify({ ...params, ok: 'hmm' }, { arrayFormat: 'indices' })
          },
          responseType: 'blob',
          headers: {},
        })
        .then(response => {
          if (response === undefined) {
            errorMessage.value = `Kode error 500, No response from server`
            return
          }
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `laporan-transaksi-per-brand_${moment().format('DDMMYY_HHmm')}.xlsx`,
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(async error => {
          errorMessage.value = null
          if (error.response) {
            const { status, statusText } = error.response
            const message = JSON.parse(await error.response.data.text()).message
            errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
          }
        })
        .finally(() => {
          state.isDownloading = false
        })
    }
    const state = reactive({
      loading: false,
      isFetching: false,
      isDownloading: false,
    })
    onMounted(() => {
      fetchData()
    })

    const search = () => {
      fetchData()
    }

    const title = computed(() => {
      return 'Performance Brand'
    })

    return {
      q,
      searchText,
      searchInput,
      data,
      current1,
      opco,
      provinsi,
      kabupaten,
      area,
      brand,
      state,
      fetchXlsx,
      distributor,
      fetchData,
      ...toRefs(state),
      start_date,
      end_date,
      startDate,
      endDate,
      search,
      errorMessage,
      disabledStartDate,
      disabledEndDate,
      firstDayMonth,
      lastDayMonth,
      columns,
      response,
      title,
    }
  },
})
</script>
